/*
 * <nl-product-rail data-url="...recommendations?section_id=...&product_id=...">
 * Loads Product Recommendations for the utility rail (sections/nl-utility-product-rail.liquid) when the rail scrolls
 * near the viewport and swaps the server rendered collection fallback for them. Hides the section when neither source
 * has products, and (data-rail-hide-empty on the section) whenever the cart becomes empty.
 */
(() => {
  'use strict';

  if (customElements.get('nl-product-rail')) return;

  class NLProductRail extends HTMLElement {
    connectedCallback() {
      if (this._bound) return;
      this._bound = true;
      this.section = this.closest('.nl-product-rail');

      if (this.section && this.section.hasAttribute('data-rail-hide-empty')) {
        this.onCart = (event) => {
          const cart = event.detail && event.detail.cart;
          if (!cart) return;
          if (cart.item_count === 0) this.section.hidden = true;
          else if (this.hasProducts()) this.section.hidden = false;
        };
        document.addEventListener('cart:updated', this.onCart);
      }

      if (!this.dataset.url) return;
      if (!('IntersectionObserver' in window)) {
        this.load();
        return;
      }
      this.observer = new IntersectionObserver(
        (entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          this.observer.disconnect();
          this.load();
        },
        { rootMargin: '0px 0px 600px 0px' }
      );
      this.observer.observe(this);
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      if (this.onCart) document.removeEventListener('cart:updated', this.onCart);
      this._bound = false;
    }

    hasProducts() {
      return Boolean(this.querySelector('[data-rail-product]'));
    }

    async load() {
      const content = this.querySelector('[data-rail-content]');
      if (!content) return;
      content.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(this.dataset.url, { credentials: 'same-origin' });
        if (!response.ok) throw new Error(String(response.status));
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const fresh = doc.querySelector('[data-rail-content]');
        if (fresh && fresh.querySelector('[data-rail-product]')) {
          content.replaceChildren(...Array.from(fresh.childNodes));
        }
      } catch (error) {
        /* keep the collection fallback */
      } finally {
        content.removeAttribute('aria-busy');
        if (this.section && !this.hasProducts()) this.section.hidden = true;
      }
    }
  }

  customElements.define('nl-product-rail', NLProductRail);
})();
